import { queryOptions, useQuery } from '@tanstack/react-query'
import { COMMUNITY_API_PREFIX } from 'shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import useUser from 'shared/hooks/use-user'
import { communityPostKeys } from 'modules/community/api/key-factory'
import type { PostInterface } from 'modules/community/types/post-interface'

export interface UsePostProps {
  communityPath?: string
  topicPath?: string
  postPath: string
}

interface UsePostResult {
  data: PostInterface | undefined
  error: Error | null
  isFetching: boolean
}

export function usePost({ communityPath, topicPath, postPath }: UsePostProps): UsePostResult {
  const { user } = useUser()

  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.get, PostInterface>({
    method: RequestMethodsEnum.get,
  })

  const query = useQuery(
    queryOptions({
      queryKey: communityPostKeys.detail(communityPath ?? '', topicPath ?? '', postPath),
      queryFn: () =>
        fetcher(`${COMMUNITY_API_PREFIX}/${communityPath}/topic/${topicPath}/post/${postPath}`),
      enabled: Boolean(communityPath && topicPath && user),
    }),
  )

  return {
    data: query.data,
    error: query.error,
    isFetching: query.isFetching,
  }
}
